<template>
  <PopupBox :title="$t('new_object', { object: $t('models.emo') })">
    <template v-slot:control>
      <button class="btn btn-sm" @click="onCloseNewEmoPopup">
        <show-icon name="close" size="sm"></show-icon>
      </button>
    </template>
    <div style="height: 75vh" class="overflow-auto text-start">
      <ul class="list-group">
        <li class="list-group-item">
          <router-link :to="{name: 'NewEmo', query: { site_id: siteId, location_id: locationId } }">
          Blank
          </router-link>
        </li>
        <li class="list-group-item" v-for="emo_template in emo_templates" :key="emo_template.uuid">
          <router-link :to="{ name: 'NewEmo', 
                              query: { 
                                site_id: siteId, 
                                asset_id: assetId, 
                                location_id: locationId, 
                                emo_template_id: emo_template.uuid 
                              }
                            }">
          {{ emo_template.name }}
          </router-link>
        </li>
      </ul>
    </div>
  </PopupBox>
</template>

<script>
import { useStore } from 'vuex'
import PopupBox from '@/components/PopupBox.vue'

export default {
  name: "NewEmoPopup",
  setup() {
    const store = useStore();
    const emo_templates = store.getters.getAllEmoTemplates
    return {
      emo_templates
    }    
  },
  props: [
    "siteId",
    "locationId",
    "assetId"
  ],
  emits: [
    "closeNewEmoPopup"
  ],
  methods: {
    onCloseNewEmoPopup() {
      this.$emit("closeNewEmoPopup");
    }
  },
  components: {
    PopupBox
  }  
}
</script>